import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "g-container g-container--variant_default g-container--space_lg g-container--space_xl-mac" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.offers.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ds-section__element",
        id: _ctx.$attrs.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {
            isAvailableScroll: $setup.isAvailable,
            prevSlide: $setup.prevSlide,
            nextSlide: $setup.nextSlide,
            isHasPrev: $setup.isHasPrev,
            isHasNext: $setup.isHasNext
          }),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sk-space_mb sk-space_mb--5 sk-space_mb--10-xl" }, null, -1)),
          (_openBlock(), _createElementBlock("div", {
            class: "products-list products-list--appearance_snap-carousel",
            key: $setup.offers.length,
            ref: "sliderRef"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.offers, (item, index) => {
              return (_openBlock(), _createBlock($setup["ProductMainPreview"], {
                key: `${item.id}_${index}`,
                item: item
              }, null, 8, ["item"]))
            }), 128)),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "products-list__fix-border-top-right" }, null, -1)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "products-list__fix-border-bottom-left" }, null, -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "products-list__fix-border-bottom-right" }, null, -1))
          ]))
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}